'use strict';

var $ = require('jquery');

// Check if user already interacted
if (localStorage.popup_closed || sessionStorage.popup_clicked) {
	$('.app-popup').remove();
}

// Check for mobile
$('.app-popup .close').click(function(e) {
	e.preventDefault;
	$(this).parent().removeClass('open');
	localStorage.popup_closed = true;
});

$('.app-popup a').click(function(e) {
	sessionStorage.popup_clicked = true;
});
